import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { CreditReviewCompliance, CreditReviewComplianceSchema } from './types/credit-review.compiance';
import { VerifiedCompanyDetails, VerifiedCompanyDetailsSchema } from './types/business-verification.ts/credit-review.business-verification';
import {
    CreditReviewBankAccountActivity,
    CreditReviewBankAccountActivitySchema,
} from './types/bank-account-activity/bank-account-activity';
import { CreditReviewStatus } from './credit-review.status.enum';
import {
    CreditScore,
    RecommendedCreditLimit,
    CreditScoreSchema,
    RecommendedCreditLimitSchema,
    InternationalScore,
    InternationalScoreSchema,
} from './notes/credit-review-notes.entity';
import { CreditReviewFinancialStatement, CreditReviewFinancialStatementSchema } from './types/credit-safe-report.financial-statement';

export const CreditReviewSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string(),
        status: EnumSchema(CreditReviewStatus),
        summary: z.string().optional(),
        businessVerification: VerifiedCompanyDetailsSchema.optional(),
        identityVerification: z.any().optional(),
        bankAccountActivity: CreditReviewBankAccountActivitySchema.optional(),
        financialStatement: CreditReviewFinancialStatementSchema.optional(),
        compliance: CreditReviewComplianceSchema.optional(),
        creditInsurance: z.any().optional(),
        documents: z.any().optional(),

        creditScore: CreditScoreSchema.optional(),
        internationalScore: InternationalScoreSchema.optional(),
        recommendedCreditLimit: RecommendedCreditLimitSchema.optional(),
    }),
).strict();

export class CreditReview extends FromSchema(CreditReviewSchema) implements BaseEntity {
    id: string;
    buyer: string;
    status: CreditReviewStatus;

    summary?: string;
    businessVerification?: VerifiedCompanyDetails;
    bankAccountActivity?: CreditReviewBankAccountActivity;
    financialStatement?: CreditReviewFinancialStatement;
    compliance?: CreditReviewCompliance;

    creditScore?: CreditScore;
    internationalScore?: InternationalScore;
    recommendedCreditLimit?: RecommendedCreditLimit;

    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    seller: string;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
